import { render } from "./ReservsFooter.vue?vue&type=template&id=4670b898"
import script from "./ReservsFooter.vue?vue&type=script&lang=js"
export * from "./ReservsFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__